import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
const VideoProgressBar = (props) => {
    const { playerStatus, videoRef, hidden } = props;
    const [progressPercentage, setProgressPercentage] = useState(0);
    useEffect(() => {
        if (playerStatus) {
            setProgressPercentage((playerStatus.currentTime / playerStatus.duration) * 100);
            if (playerStatus.playing) {
                videoRef.querySelector('.play-pause-button').setAttribute('aria-pressed', 'false');
            }
        }
        else {
            setProgressPercentage(0);
        }
    }, [playerStatus]);
    useEffect(() => {
        if (hidden) {
            setProgressPercentage(0);
        }
    }, [hidden]);
    const handleClickProgressBar = (e) => {
        let rect = e.target.getBoundingClientRect();
        let x = e.clientX - rect.left;
        let progressBarPercentage = (x / e.target.clientWidth) * 100;
        let timeToSet = (progressBarPercentage / 100) * playerStatus.duration;
        videoRef.querySelector('.th-video-element video').currentTime = timeToSet;
        setProgressPercentage(progressBarPercentage);
    };
    const handleDragProgressbar = (e) => {
        let rect = e.target.getBoundingClientRect();
        let x = e.changedTouches[0].clientX - rect.left;
        let progressBarPercentage = (x / e.target.clientWidth) * 100;
        let timeToSet = (progressBarPercentage / 100) * playerStatus.duration;
        videoRef.querySelector('.th-video-element video').currentTime = timeToSet;
        setProgressPercentage(progressBarPercentage);
    };
    return (React.createElement("div", { className: classNames('video-module__controls', { hidden: hidden }) },
        React.createElement("button", { "data-pause": true, "aria-pressed": "false", type: "button", "aria-label": "play-pause", className: classNames('play-pause-button') }),
        React.createElement("button", { "data-mute": true, "aria-pressed": "false", type: "button", "aria-label": "volume", className: classNames('volume-button') }),
        React.createElement("button", { className: "progress-bar-wrapper", onClick: (e) => handleClickProgressBar(e), onTouchEnd: (e) => handleDragProgressbar(e) },
            React.createElement("div", { className: "progress-bar" }, !hidden && React.createElement("span", { className: "progress", style: { width: `${progressPercentage || 0}%`, transition: progressPercentage === 0 ? 'all 0s' : 'all 0.2s linear' } })))));
};
export default VideoProgressBar;
